import { Customers, CREATE_CUSTOMERS } from "./types";

export function createCustomers(customers: Customers) {
  return {
    type: CREATE_CUSTOMERS,
    payload: customers,
  };
}
